$ = jQuery = require('jquery');

function macyItems(target) {
    // console.log(jQuery('#' + target));
    Macy({
        container: '#' + target + '',
        trueOrder: true,
        waitForImages: false,
        margin: 40,
        columns: 2,
        mobileFirst: true,
        breakAt: {
            1025: 4,
        }
    });
    jQuery(window).trigger('resize');
}

function triggerResize() {
    if (typeof(Event) === 'function') {
        // modern browsers
        window.dispatchEvent(new Event('resize'));
    } else {
        // for IE and other old browsers
        // causes deprecation warning on modern browsers
        var evt = window.document.createEvent('UIEvents'); 
        evt.initUIEvent('resize', true, false, window, 0); 
        window.dispatchEvent(evt);
    }
}

function resizeHeader() {
    if ($('body').hasClass('absolute-header')) {
        var scrollingElementHeight = $('.fixed-scrolling-element >*:first-child').outerHeight();
        // if ($('body').hasClass('admin-bar')) {
        //     scrollingElementHeight += $('#wpadminbar').outerHeight();
        // }
        // console.log(scrollingElementHeight);
        $('.header-section-wrapper + *').css({"margin-top": scrollingElementHeight + "px"});
    }
}

function setNavToggled() {
    document.body.classList.toggle( 'no-scroll' );

    if (document.body.classList.contains( 'no-scroll' )) {
        var scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${(scrollY - $('#wpadminbar').outerHeight())}px`;
    } else {
        var scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
}

function toggleMenuVisibility(visible) {
    if (visible === undefined) {
        visible = !$('#site-navigation').hasClass('toggled');
    }
    setNavToggled();
    if (visible) {
        if ($('#search-drop').hasClass('active')) {
            $('#search-drop').removeClass('active');
        }
        $('#navigation-drop').addClass('active');
        $('#navigation-drop').addClass('animation-active');
        $('#site-navigation').addClass('toggled');
        if (!$('#navigation-drop').hasClass('active')) {
            $('.header-section-wrapper').removeClass('active');
        } else {
            $('.header-section-wrapper').addClass('active');
        }
        triggerResize();
    } else {
        $('#navigation-drop').removeClass('active');
        $('#site-navigation').removeClass('toggled');
        $('.header-section-wrapper').removeClass('active');
        $('div[class^="menu-"][class$="-container"] ul > li.active').removeClass('active');
        $('.navigation-wrapper.active').removeClass('active');
    }
}

jQuery(document).ready(function($) {

    resizeHeader();
    $(window).on('resize', function() {
        resizeHeader();
    });

    function ajaxLoadProducts(scrollToTop) {
        // Default to false
        scrollToTop = scrollToTop || false;
        var tpl = $('#product-grid-template').html();
        $('.collapsible.all-active input[type="checkbox"]').prop('checked', true);
        $('.products-grid').addClass('loading');
    
        // Use fetch instead of Ext.Ajax.request
        fetch(ajax.url + '?' + $('#filter-products-form').serialize(), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            timeout: 60000 // You can add a timeout handler if necessary
        })
        .then(response => response.json()) // Equivalent to Ext.decode
        .then(obj => {
            // Clear the products grid
            $('.products-grid ul.products').html('');
            console.log(obj);
    
            // Iterate through products and update the grid
            $.each(obj.products, function(index, value) {
                // Replace placeholders in the template with actual values from the response
                var html = tpl.replace('{category}', value.category)
                              .replace('{brand}', value.brand)
                              .replace('{img}', value.image)
                              .replace('{title}', value.title)
                              .replace('{excerpt}', value.excerpt)
                              .replace('{link}', value.permalink);
    
                // Append the HTML to the products grid
                $('.products-grid ul.products').append(html);
            });
    
            // Update page elements with the new data
            $('span.num-products-showing').html(obj.products.length);
            $('span.num-products-visible').html(obj.num_posts);
            $('#page-header .product-description').html(obj.heading_content);
            $('#page-header').removeClass();
            $('.fixed-scrolling-element .products-banner').removeClass().addClass('products-banner');
            $('.fixed-scrolling-element .products-banner').addClass(obj.heading_brand_slug);
            $('.fixed-scrolling-element .products-banner img').attr('src', obj.heading_image);
            $('#page-header').addClass('brand-' + obj.heading_brand_slug);
            $('.pagination').html(obj.pagination);
    
            // Handle pagination clicks
            $('.pagination a').on('click', function(e) {
                e.preventDefault();
                if ($(this).hasClass('prev')) {
                    $('#products-current-page').val(parseInt($('#products-current-page').val()) - 1);
                } else if ($(this).hasClass('next')) {
                    $('#products-current-page').val(parseInt($('#products-current-page').val()) + 1);
                } else {
                    $('#products-current-page').val($(this).html());
                }
                ajaxLoadProducts(true);
            });
    
            // Remove loading class from the products grid
            $('.products-grid').removeClass('loading');
    
            // Scroll to the top of the grid if scrollToTop is true
            if (scrollToTop) {
                $('html, body').animate({
                    scrollTop: $('.products-grid').offset().top - 100
                }, 500);
            }
        })
        .catch(error => {
            // Handle request failure, similar to Ext.Msg.alert in ExtJS
            alert('Request Failed: ' + error.message);
            console.log(error);
        });
    }
    

    if ($('.product-filters input[type="checkbox"]:checked').length) {
        ajaxLoadProducts();
    }

    if ($('.product-filters').length) {
        $(window).on('scroll', function(){
            if ($('.responsive-triggers .tablet-landscape-trigger').is(':visible')) {
                if ($('.product-filters').outerHeight() > $(window).height()) {
                    $('.product-filters').removeClass('sticky');
                    $('.product-filters').css({'top': '0'});
                } else {
                    $('.product-filters').addClass('sticky');
                    $('.product-filters').css({'top': ($('.fixed-scrolling-element').length ? $('.fixed-scrolling-element').outerHeight() : 0) + ($('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0) + 'px'});
                }
            } else {
                $('.product-filters').removeClass('sticky');
                $('.product-filters').css({'top': '0'});
            }
        });
        $(window).on('resize', function(){
            if ($('.responsive-triggers .tablet-landscape-trigger').is(':visible')) {
                if ($('.product-filters').outerHeight() > $(window).height()) {
                    $('.product-filters').removeClass('sticky');
                    $('.product-filters').css({'top': '0'});
                } else {
                    $('.product-filters').addClass('sticky');
                    $('.product-filters').css({'top': ($('.fixed-scrolling-element').length ? $('.fixed-scrolling-element').outerHeight() : 0) + ($('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0) + 'px'});
                }
            } else {
                $('.product-filters').removeClass('sticky');
                $('.product-filters').css({'top': '0'});
            }
            $('.product-filters').removeClass('animation-active');
            if (!$('.responsive-triggers .tablet-landscape-trigger').is(':visible') && $('body').hasClass('filter-open')) {
                $('body').removeClass('modal-open').removeClass('subscribe-overlay-active').removeClass('product-enquiry-overlay-active').removeClass('filter-open');
                window.scrollTo(0, parseInt($('body').css('top')) * -1);
                $('body').css({'top': ''});
            }
        });
    }

    /* AJAX Add to Cart */
    jQuery(function($) {

        $('#site-secondary-nav a.search, #search-form a.close').on('click', function(e) {
            if ($('#navigation-drop').hasClass('active')) {
                $('#navigation-drop').removeClass('active');
            }
            $('#search-drop').toggleClass('active');
            $('#search-drop').addClass('animation-active');
            // if (!$('#search-drop').hasClass('active')) {
            //     $('.header-section-wrapper').removeClass('active');
            // } else {
            //     $('.header-section-wrapper').addClass('active');
            // }
            e.preventDefault();
        });

        $('#site-navigation').find('ul.menu').find('>li.menu-item-has-children').each(function() {
            var subMenu = $(this).find('>ul.sub-menu').clone();
            var subMenuMobile = $(this).find('>ul.sub-menu').clone();
            id = 'container-' + $(this).attr('id');
            subMenu.attr('id', id);
            subMenuMobile.attr('id', 'mobile-' + id);
            
            var isMegaMenu = false;

            subMenu.find('>li').each(function() {
                if ($(this).hasClass('menu-item-has-children')) {
                    isMegaMenu = true;
                }
            });

            if (isMegaMenu) {
                subMenu.addClass('mega-menu');
            }

            var menuContainer = $('<div></div>');
            menuContainer.addClass('navigation-wrapper');
            menuContainer.attr('data-menu', $(this).attr('id'));
            menuContainer.append(subMenu);
            menuContainer.addClass('processed');
            $('#navigation-drop .contain').append(menuContainer);
            if (isMegaMenu) {
                menuContainer.removeClass('processed');
                macyItems(id);
                setTimeout(function() {
                    menuContainer.addClass('processed');
                }, 10);
            }
            var menuContainerMobile = $('<div></div>');
            menuContainerMobile.addClass('navigation-wrapper');
            menuContainerMobile.attr('data-menu', $(this).attr('id'));
            menuContainerMobile.append(subMenuMobile);
            menuContainerMobile.addClass('processed');
            $('.mobile-menu-second-tier').append(menuContainerMobile);
        });

        $('#site-navigation .menu-toggle').on('click', function(e) {
            $('.main-navigation-wrapper').addClass('animation-active');
            toggleMenuVisibility(true);
            e.preventDefault();
        });

        $('#site-navigation div[class^="menu-"][class$="-container"] ul li.close button').on('click', function(e) {
            $('.main-navigation-wrapper').addClass('animation-active');
            toggleMenuVisibility(false);
            e.preventDefault();
        });

        $('div[class^="menu-"][class$="-container"] > ul > li.menu-item-has-children > a').on('click', function(e) {

            //do desktop stuff for navigation
            if ($('.responsive-triggers .navigation-trigger').is(':visible')) {
                if ($(this).parent().hasClass('active')) {
                    toggleMenuVisibility(false);
                    $(this).parent().removeClass('active');
                    $('.slide-navigation-mobile').toggleClass('active');
                    $('.navigation-wrapper.active').removeClass('active');
                } else {
                    toggleMenuVisibility(true);
                    $('div[class^="menu-"][class$="-container"] ul > li.menu-item-has-children.active').removeClass('active');
                    $(this).parent().addClass('active');
                }
            } else {
                //do mobile stuff for navigation
                if (!$(this).parent().hasClass('active')) {
                    $(this).parent().parent().find('li.menu-item-has-children.active').removeClass('active');
                }
                $(this).parent().toggleClass('active');
                $('.slide-navigation-mobile').toggleClass('active');
            }
            var menu_visible = $(this).parent().attr('id');
            if (!$(this).parent().hasClass('active')) {
                $('.navigation-wrapper[data-menu="' + menu_visible + '"]').removeClass('active');
            } else {
                $('.navigation-wrapper.active').removeClass('active');
                $('.navigation-wrapper[data-menu="' + menu_visible + '"]').addClass('active');
            }
            e.preventDefault();
        });

        $('.slide-navigation-mobile .back a').on('click', function(e) {
            $('.slide-navigation-mobile').toggleClass('active');
            $('.navigation-wrapper.active').removeClass('active');
            $('div[class^="menu-"][class$="-container"] > ul > li.menu-item-has-children.active').removeClass('active');
        });

        $('div[class^="menu-"][class$="-container"] ul.sub-menu > li.menu-item-has-children > a').on('click', function(e) {
            if (!$('.responsive-triggers .navigation-trigger').is(':visible')) {
                if (!$(this).parent().hasClass('active')) {
                    $(this).parent().parent().find('li.menu-item-has-children.active').removeClass('active');
                }
                $(this).parent().toggleClass('active');
            }
        });

        $('#site-navigation').find('ul.menu').find('li.menu-item-has-children > a').on('click', function(e) {
            e.preventDefault();
        });

        if ($('.reset-filter-btn').length) {
            $('.reset-filter-btn').on('click', function(e) {
                $('#products-current-page').val(1);
                $('.product-filters input[type="checkbox"]').prop('checked', false);
                $('.product-filters .collapsible').removeClass('all-active');
                ajaxLoadProducts();
                if (!$('.responsive-triggers .tablet-landscape-trigger').is(':visible')) {
                    $('body').removeClass('modal-open').removeClass('subscribe-overlay-active').removeClass('product-enquiry-overlay-active').removeClass('filter-open');
                    window.scrollTo(0, parseInt($('body').css('top')) * -1);
                    $('body').css({'top': ''});
                }
                e.preventDefault();
            });
        }

        if ($('.products-grid-per-page').length) {
            var productsPerPage = localStorage.getItem('productsPerPage');
            if (productsPerPage) {
                $('.products-grid-per-page ul li').removeClass('active');
                $('.products-grid-per-page ul li a[data-per-page="' + productsPerPage + '"]').parent().addClass('active');
                $('#products-per-page').val(productsPerPage);
            } else {
                $('.products-grid-per-page ul li a.default').parent().addClass('active');
                $('#products-per-page').val($('.products-grid-per-page ul li a.default').attr('data-per-page'));
            }
            ajaxLoadProducts();
            $('.products-grid-per-page ul li a').bind('click', function(e) {
                var perPage = $(this).attr('data-per-page');
                localStorage.setItem('productsPerPage', perPage);
                $('#products-current-page').val(1);
                $('.products-grid-per-page ul li').removeClass('active');
                $(this).parent().addClass('active');
                $('#products-per-page').val(perPage);
                ajaxLoadProducts();
                e.preventDefault();
            });
        }

        if ($('.product-documentation .section-heading .action').length) {
            var documentsPerPage = localStorage.getItem('documentsPerPage');
            if (documentsPerPage == undefined || documentsPerPage == null) {
                documentsPerPage = 15;   
            }
            $('input[name=posts_per_page]').val(documentsPerPage);
            $('#posts_per_page_select').addClass('filled');
            $('.product-documentation .section-heading .action select#posts_per_page_select').val(documentsPerPage);
            update_filters_documentation(null, 1, false);
        }

        $('#posts_per_page_select').on('change', function(e) {
            var perPage = $(this).val();
            localStorage.setItem('documentsPerPage', perPage);
            $('input[name=posts_per_page]').val(perPage);
            update_filters_documentation();
        });

        if ($('.product-filters').length) {
            $('.collapsible .collapsible-header a').on('click', function(e) {
                $(this).parent().parent().toggleClass('expanded');
                if ($('.responsive-triggers .tablet-landscape-trigger').is(':visible')) {
                    var _this = $(this).parent().parent();
                    window.setTimeout(function() {
                        if ($('.product-filters').outerHeight() > $(window).height()) {
                            $('.product-filters').removeClass('sticky');
                            $('.product-filters').css({'top': '0'});
                        } else {
                            $('.product-filters').addClass('sticky');
                            $('.product-filters').css({'top': ($('.fixed-scrolling-element').length ? $('.fixed-scrolling-element').outerHeight() : 0) + ($('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0) + 'px'});
                        }
                        //scroll to the top of the page
                        if (_this.hasClass('expanded') && !$('.product-filters').hasClass('sticky')) {
                            $('html, body').animate({
                                scrollTop: _this.offset().top - 200
                            });
                        }
                    }, 500);
                }
                e.preventDefault();
            });
            $('.product-filters input[type="checkbox"]').each(function() {
                if ($(this).is(':checked')) {
                    if ($(this).attr('data-all-active')) {
                        $('.product-filters .collapsible.' + $(this).attr('data-all-active')).toggleClass('all-active');
                    }
                    if ($(this).attr('data-disables')) {
                        var numMatchingFilters = $('.product-filters input[data-disables="' + $(this).attr('data-disables') + '"]').length;
                        var numMatchingFiltersChecked = $('.product-filters input[data-disables="' + $(this).attr('data-disables') + '"]:checked').length;
                        if (numMatchingFilters == numMatchingFiltersChecked) {
                            $('.product-filters .collapsible.' + $(this).attr('data-disables')).toggleClass('all-active');
                            $('.product-filters input[data-all-active="' + $(this).attr('data-disables') + '"]').prop('checked', true);
                        }
                    }
                }
            });
            $('.product-filters input[type="checkbox"]').on('change', function() {
                $('#products-current-page').val(1);
                if ($(this).parents('.collapsible').hasClass('all-active')) {
                    $(this).parents('.collapsible').toggleClass('all-active');
                    $('.product-filters input[data-all-active="' + $(this).attr('data-disables') + '"]').prop('checked', false);
                }
                if ($(this).attr('data-all-active')) {
                    $('.product-filters .collapsible.' + $(this).attr('data-all-active')).toggleClass('all-active');
                    if (!$(this).is(':checked')) {
                        $('.product-filters .collapsible.' + $(this).attr('data-all-active')).find('input[type="checkbox"]').prop('checked', false);
                    }
                }
                if ($(this).attr('data-disables')) {
                    var numMatchingFilters = $('.product-filters input[data-disables="' + $(this).attr('data-disables') + '"]').length;
                    var numMatchingFiltersChecked = $('.product-filters input[data-disables="' + $(this).attr('data-disables') + '"]:checked').length;
                    if (numMatchingFilters == numMatchingFiltersChecked) {
                        $('.product-filters input[data-all-active="' + $(this).attr('data-disables') + '"]').prop('checked', true);
                        $(this).parents('.collapsible').addClass('all-active');
                    }
                }
                ajaxLoadProducts();
            });
        }

    });

    function updateActiveSection(scrollPercentage) {
        var steps = [
            {
                start: 0,
                end: 0.3,
                child: 1
            },
            {
                start: 0.3,
                end: 0.6,
                child: 2
            },
            {
                start: 0.6,
                end: 1,
                child: 3
            }
        ];
        for (var i = 0; i < steps.length; i++) {
            if (scrollPercentage > steps[i].start && scrollPercentage <= steps[i].end) {
                var currentDistance = (scrollPercentage - steps[i].start) / (steps[i].end - steps[i].start);
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.save();
                // ctx.globalAlpha = currentDistance;
                drawImageProp(ctx, img[steps[i].child], 0, 0, canvas.width, canvas.height);
                ctx.restore();
            } else {
                // drawImageProp(ctx, img[1], 0, 0, canvas.width, canvas.height);
            }
        }
    }

    function resetImageScrollOpacity() {
        $('.expand.clone .image-placeholder:nth-child(1)').css({'opacity': 1});
        $('.expand.clone .image-placeholder:nth-child(n+2)').css({'opacity': 0});
    }

    var scrollPercentage;

    function checkExpand(target, clone) {
        if (clone.length && !clone.hasClass('hidden') && clone.position().top == 0) {
            target.addClass('active');
            var minScroll = target.offset().top;
            var maxScroll = (target.offset().top + target.outerHeight() - clone.outerHeight());
            var currentScroll = $(window).scrollTop();
            
            //determine the current scroll percentage between min and max and clamp it between 0 and 1
            scrollPercentage = (currentScroll - minScroll) / (maxScroll - minScroll);
            scrollPercentage = Math.min(scrollPercentage, 1);
            scrollPercentage = Math.max(scrollPercentage, 0);

            updateActiveSection(scrollPercentage);
        } else {
            target.removeClass('active');
        }

        if ($(window).scrollTop() - target.offset().top >= 0 && !clone.length) {
            var clone = target.clone();
            clone.addClass('clone');
            clone.addClass('fixed');
            $('#canvas').remove();
            target.append(clone);
            setupCanvas()
        } else if ($(window).scrollTop() - target.offset().top >= 0 && clone.length && clone.hasClass('hidden')) {
            clone.removeClass('hidden').addClass('fixed');
        }
        if (clone.length) {
            clonePos = clone.offset().top + clone.outerHeight();
            expandPos = target.offset().top + target.outerHeight();
            // fixPosChange = $(window).scrollTop() - (target.offset().top + (target.outerHeight() - $(window).outerHeight()));
            fixPosChange = $(window).scrollTop() - (target.offset().top + (target.outerHeight() - clone.outerHeight()));
            if (clonePos >= expandPos && !clone.hasClass('absolute') && !clone.hasClass('hidden')) {
                clone.removeClass('fixed').addClass('absolute');
            } else if (fixPosChange <= 0 && clone.hasClass('absolute')) {
                clone.removeClass('absolute').addClass('fixed');
            } else if ($(window).scrollTop() <= target.offset().top && clone.hasClass('fixed') && !clone.hasClass('absolute')) {
                clone.removeClass('fixed').addClass('hidden');
            }
        }
    }

    function checkFixedScrollingElementPos() {
        if ($('.fixed-scrolling-element').length) {
            var currentScroll = $(window).scrollTop();
            var headerBottomPos = $('.header-section-wrapper').offset().top + $('.header-section-wrapper').outerHeight() - ($('body').hasClass('admin-bar') ? $('#wpadminbar').outerHeight() : 0);
            if (currentScroll >= headerBottomPos) {
                $('.fixed-scrolling-element').addClass('fixed');
                if ($('body').hasClass('admin-bar')) {
                    $('.fixed-scrolling-element').css({'top': $('#wpadminbar').outerHeight() + 'px'});
                }
            } else {
                $('.fixed-scrolling-element').removeClass('fixed');
            }
        }
    }

    // Canvas animation on the homepage

	jQuery(document).ready(function($){
        if ($('.expand').length) {
            if ($('.expand').parent().hasClass('wp-block-group')) {
                $('.expand').parent().addClass('wp-block-group-expand');
            }
            //work out the window height and set the height of the expand to be the same
            var windowHeight = $(window).height();
            //minus the height of the header
            windowHeight -= $('.header-section-wrapper').outerHeight();
            //check if admin bar is visible
            if ($('body').hasClass('admin-bar')) {
                windowHeight -= $('#wpadminbar').outerHeight();
            }
            var paddingExpand = parseInt(window.getComputedStyle($('.wp-block-group-expand')[0], null).getPropertyValue('padding-top'));
            paddingExpand += parseInt(window.getComputedStyle($('.wp-block-group-expand')[0], null).getPropertyValue('padding-bottom'));
            $('.wp-block-group-expand .expand').css({'height': (windowHeight + paddingExpand) + 'px'});
            $('.wp-block-group-expand').css({'height': '0px'});
            $('.expand-content-wrapper').children().each(function() {
                var padding = parseInt(window.getComputedStyle($(this)[0], null).getPropertyValue('padding-top'));
                padding += parseInt(window.getComputedStyle($(this)[0], null).getPropertyValue('padding-bottom'));
                $(this).css({'height': (windowHeight + padding) + 'px'});
                var margin = parseInt(window.getComputedStyle($(this)[0], null).getPropertyValue('padding-top'));
                margin += parseInt(window.getComputedStyle($(this)[0], null).getPropertyValue('padding-bottom'));
                $('.wp-block-group-expand').css({'height': '+=' + (windowHeight + margin + padding) + 'px'});
            });

            //create a canvas element and add the content of the expand to it
            var canvas = document.createElement('canvas');
            canvas.id = 'canvas';
            if (window.innerWidth > 1920) {
                canvas.width = 1920;
            } else {
                canvas.width = window.innerWidth;
            }
            canvas.height = windowHeight;
            $('.expand').append(canvas);
            var ctx = canvas.getContext('2d');
            // ctx.fillRect(0, 0, canvas.width, canvas.height);
            //add the text content of the expand to the canvas
            var fps, fpsInterval, startTime, now, then, elapsed;
            startAnimating(60);
            window.onresize = function() {
                var windowHeight = $(window).height();
                //minus the height of the header
                windowHeight -= $('.header-section-wrapper').outerHeight();
                //check if admin bar is visible
                if ($('body').hasClass('admin-bar')) {
                    windowHeight -= $('#wpadminbar').outerHeight();
                }
                var paddingExpand = parseInt(window.getComputedStyle($('.wp-block-group-expand .expand')[0], null).getPropertyValue('padding-top'));
                paddingExpand += parseInt(window.getComputedStyle($('.wp-block-group-expand .expand')[0], null).getPropertyValue('padding-bottom'));
                $('.wp-block-group-expand .expand').css({'height': (windowHeight + paddingExpand) + 'px'});
                $('.wp-block-group-expand').css({'height': '0px'});
                $('.expand-content-wrapper').children().each(function() {
                    var padding = parseInt(window.getComputedStyle($(this)[0], null).getPropertyValue('padding-top'));
                    padding += parseInt(window.getComputedStyle($(this)[0], null).getPropertyValue('padding-bottom'));
                    $(this).css({'height': (windowHeight + padding) + 'px'});
                    var margin = parseInt(window.getComputedStyle($(this)[0], null).getPropertyValue('padding-top'));
                    margin += parseInt(window.getComputedStyle($(this)[0], null).getPropertyValue('padding-bottom'));
                    $('.wp-block-group-expand').css({'height': '+=' + (windowHeight + margin + padding) + 'px'});
                });
                if (window.innerWidth > 1920) {
                    canvas.width = 1920;
                } else {
                    canvas.width = window.innerWidth;
                }
                canvas.height = windowHeight;
            }
        }
        function wrapText(context, text, x, y, maxWidth, lineHeight) {
            var words = text.split(' ');
            var line = '';
    
            for(var n = 0; n < words.length; n++) {
              var testLine = line + words[n] + ' ';
              var metrics = context.measureText(testLine);
              var testWidth = metrics.width;
              if (testWidth > maxWidth && n > 0) {
                context.fillText(line, x, y);
                line = words[n] + ' ';
                y += lineHeight;
              }
              else {
                line = testLine;
              }
            }
            context.fillText(line, x, y);
        }
        function startAnimating(fps) {
            fpsInterval = 1000 / fps;
            then = Date.now();
            startTime = then;
            animate();
        }

        var fitImageOn = function(context, canvas, imageObj) {
            var imageAspectRatio = imageObj.width / imageObj.height;
            var canvasAspectRatio = canvas.width / canvas.height;
            var renderableHeight, renderableWidth, xStart, yStart;
        
            // If image's aspect ratio is less than canvas's we fit on height
            // and place the image centrally along width
            if(imageAspectRatio > canvasAspectRatio) {
                renderableHeight = canvas.height;
                renderableWidth = imageObj.width * (renderableHeight / imageObj.height);
                xStart = (canvas.width - renderableWidth) / 2;
                yStart = 0;
            }
        
            // If image's aspect ratio is greater than canvas's we fit on width
            // and place the image centrally along height
            else if(imageAspectRatio < canvasAspectRatio) {
                renderableWidth = canvas.width
                renderableHeight = imageObj.height * (renderableWidth / imageObj.width);
                xStart = 0;
                yStart = (canvas.height - renderableHeight) / 2;
            }
        
            // Happy path - keep aspect ratio
            else {
                renderableHeight = canvas.height;
                renderableWidth = canvas.width;
                xStart = 0;
                yStart = 0;
            }
            context.drawImage(imageObj, xStart, yStart, renderableWidth, renderableHeight);
        };

        var lastImage = 1;

        // Does stuff

        function animate() {
            requestAnimationFrame(animate);
            var totalImages = $('.expand .images').children().length;
            var totalSlides = $('.expand .expand-content-wrapper').children().length;
            var imagesPerSlide = totalImages / totalSlides;
            var currentImage = 0;
            var headingText = '';
            var contentText = '';
            var textOpacity = 0;
            var textPos = 0;
            // console.log(totalImages, totalSlides);
            now = Date.now();
            elapsed = now - then;
            var currentImage = null;
            if (elapsed > fpsInterval) {
                then = now - (elapsed % fpsInterval);
                // drawStuff();
                //clear the canvas
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                //check the top position of the child
                var currentScroll = $(window).scrollTop();
                var windowHeight = $(window).height();
                //minus the height of the header
                var subtractAmount = $('.header-section-wrapper').outerHeight();
                //check if admin bar is visible
                if ($('body').hasClass('admin-bar')) {
                    subtractAmount += $('#wpadminbar').outerHeight();
                }
                windowHeight -= subtractAmount;

                //only do stuff if the expand-content-wrapper child is in the viewport
                $('.expand-content-wrapper').children().each(function() {
                    var scrollPos = $(this).offset().top - (currentScroll + subtractAmount);
                    //offset scroll pos by the half the height of the page
                    scrollPos -= windowHeight / 2;
                    var scrollPercentage = (scrollPos / windowHeight) * -1;
                    if (scrollPercentage < 0) {
                        scrollPercentage = 0;
                    }
                    if (scrollPercentage > 1) {
                        scrollPercentage = 1;
                    }
                    // console.log(scrollPercentage);
                    if (scrollPercentage < 0 && currentImage == null) {
                        currentImage = Math.floor(totalImages / totalSlides) * $(this).index();
                    }

                    if (scrollPercentage > 0 && scrollPercentage < 1) {
                        var minImage = Math.floor(totalImages / totalSlides) * $(this).index();
                        var maxImage = Math.floor(totalImages / totalSlides) * ($(this).index() + 1);
                        currentImage = Math.floor((maxImage - minImage) * scrollPercentage) + minImage;
                        // console.log(currentImage);
                        lastImage = currentImage;
                        headingText = $(this).find('.expand-content-inner .h1').html();
                        contentText = $(this).find('.expand-content-inner .content').html();
                        textPos = (windowHeight * scrollPercentage);
                        if (scrollPercentage < 0.35) {
                            //invert the scroll percentage
                            textOpacity = scrollPercentage * 4;
                        } else if (scrollPercentage > 0.55) {
                            //fade out instead of in
                            textOpacity = (1 - scrollPercentage) * 4;
                        } else {
                            textOpacity = 1;
                        } 
                    }

                    if (scrollPercentage > 1 && currentImage == null) {
                        currentImage = Math.floor(totalImages / totalSlides) * ($(this).index() + 1);
                    }

                });

                if (currentImage) {
                    if (currentImage != null) {
                        fitImageOn(ctx, canvas, $('.expand .images').children(':nth-child(' + currentImage + ')')[0]);
                    }
                } else {
                    if (lastImage != null) {
                        if (lastImage == 0) {
                            lastImage = 1;
                        }
                        fitImageOn(ctx, canvas, $('.expand .images').children(':nth-child(' + lastImage + ')')[0]);
                    } else {
                        fitImageOn(ctx, canvas, $('.expand .images').children(':nth-child(1)')[0]);
                    }
                }
                // console.log(headingText, contentText);
                ctx.fillStyle = "rgba(0, 0, 0, " + textOpacity + ")";

                var font_size_percent = 13;
                var min_font_size = 26;
                var max_font_size = 80;
                var current_font_size = (canvas.width * (font_size_percent / 100));
                var lineHeight = 1.2 * (canvas.width * (font_size_percent / 100));
                if (current_font_size < min_font_size) {
                    current_font_size = min_font_size;
                    lineHeight = 1.4 * min_font_size;
                } else if (current_font_size > max_font_size) {
                    current_font_size = max_font_size;
                    lineHeight = 1.2 * max_font_size;
                }

                ctx.font = current_font_size + "px DM Sans, sans-serif";
                if (canvas.width < 1280) {
                    var x = 24;
                } else {
                    var x = (canvas.width / 2) - 640;
                }
                ctx.fillText(headingText, x, (textPos - (lineHeight + 16)));
                if (headingText || contentText) {

                    var font_size_percent = 5;
                    var min_font_size = 18;
                    var max_font_size = 32;
                    var current_font_size = (canvas.width * (font_size_percent / 100));
                    var lineHeight = 1.2 * (canvas.width * (font_size_percent / 100));
                    if (current_font_size < min_font_size) {
                        current_font_size = min_font_size;
                        lineHeight = 1.4 * min_font_size;
                    } else if (current_font_size > max_font_size) {
                        current_font_size = max_font_size;
                        lineHeight = 1.2 * max_font_size;
                    }
                    var y = textPos - lineHeight;
                    if (canvas.width < 500) {
                        var maxWidth = (canvas.width - 48);
                    } else {
                        var maxWidth = 500;
                    }
                    ctx.font = current_font_size + "px DM Sans, sans-serif";
                    wrapText(ctx, contentText, x, y, maxWidth, lineHeight);    
                }

            }
        }
        
        // checkFixedScrollingElementPos();
        // if ($('.expand').length) {
        //     $.each($('.expand:not(.clone)'), function() {
        //         var _this = $(this);
        //         var clone = _this.find('.clone');
        //         var clone = _this.clone();
        //         clone.addClass('clone');
        //         clone.addClass('hidden');
        //         $('#canvas').remove();
        //         _this.append(clone);
        //         setupCanvas();
        //     });
        // }

        $(window).on('resize', function() {
            // if ($('.expand').length) {
            //     $.each($('.expand:not(.clone)'), function() {
            //         setupCanvas();
            //     });
            // }

            $('#navigation-drop').removeClass('animation-active');
            $('.main-navigation-wrapper').removeClass('animation-active');
            setTimeout(function() {
                if (!$('#navigation-drop .navigation-wrapper.active').length && $('.responsive-triggers .navigation-trigger').is(':visible')) {
                    $('.header-section-wrapper').removeClass('active');
                } else if ($('.main-navigation').hasClass('toggled')) {
                    $('.header-section-wrapper').addClass('active');
                }
            }, 500);
        });

		$('body').on( 'adding_to_cart', function(data, $thisbutton){
			$($thisbutton).parent().block({ message: null, overlayCSS: { background: '#fff', opacity: 0.6 } });
		});

		$('body').on( 'added_to_cart', function(event, fragments, cart_hash, button){

			$(button).html($(button).data('added') + ' <span class="icon-tick"></span>');
			$(button).parent().unblock();

			// Change button text after 4 seconds
			setTimeout(function() {
				$(button).html($(button).data('add-to-cart'));
                $(button).removeClass('added');
			}, 4 * 1000);
		});

        $('.accordion').on('click', '.accordion-header', function(e) {
            if (!$(this).parent().hasClass('active')) {
                $('.accordion > li.active').removeClass('active');
            }
            $(this).parent().toggleClass('active');
            e.preventDefault();
        });

        if ($('.word-rotate').length) {
            $('.word-rotate .word').eq(0).addClass('animation-active');
            $('.word-rotate').each(function() {
                var _this = $(this);
                var currentWord = _this.find('.word.active').index();
                var prevWord = currentWord;
                var interval = setInterval(function() {
                    prevWord = currentWord;
                    currentWord++;
                    if (currentWord >= _this.find('.word').length) {
                        currentWord = 0;
                    }
                    _this.find('.word').eq(prevWord).removeClass('active');
                    _this.find('.word').eq(currentWord).addClass('active').addClass('animation-active');
                }, 3500);
            });
        }
	});

    $('#measurement_unit').on('change', function() {
        if ($(this).is(':checked')) {
            //Metric
            $('.specification-table').hide();
            $('.specification-table.metric').show();
        } else {
            //US
            $('.specification-table').hide();
            $('.specification-table.us').show();
        }
    });

    if ($('#measurement_unit').is(':checked')) {
        //Metric
        $('.specification-table').hide();
        $('.specification-table.metric').show();
    } else {
        //US
        $('.specification-table').hide();
        $('.specification-table.us').show();
    }

    $('.description-label a').on('click', function(e) {
        e.preventDefault();
        $('.specification-table').hide();
        $('.specification-table.' + $(this).html().toLowerCase()).show();
        switch ($(this).html().toLowerCase()) {
            case 'metric':
                $('#measurement_unit').prop('checked', true);
                break;
            case 'us':
                $('#measurement_unit').prop('checked', false);
                break;
        }
    });

    window.addEventListener('scroll', function(e) {
        // if ($('.expand').length) {
        //     $.each($('.expand:not(.clone)'), function() {
        //         var _this = $(this);
        //         var clone = _this.find('.clone');
        //         checkExpand(_this, clone);
        //     });
        // }
        checkFixedScrollingElementPos();
    });

    var canvas;
    var ctx;

    function setupCanvas() {
        canvas = document.getElementById('canvas');
        ctx = canvas.getContext('2d');

        canvas.height = window.innerHeight;
        canvas.width = window.innerWidth;

        ctx.fillStyle = '#000';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        img = [] 
        img[1] = new Image();
        img[1].src = '/content/themes/concentric/img/image1.jpg';
        img[2] = new Image();
        img[2].src = '/content/themes/concentric/img/image2.jpg';
        img[3] = new Image();
        img[3].src = '/content/themes/concentric/img/image3.jpg';
        ctx.globalAlpha = 1;
        img[1].onload = function() {
            drawImageProp(ctx, img[1], 0, 0, canvas.width, canvas.height);
        }


        animate();
    }

    

    function animate() {

        // console.log('animate called');
        requestAnimationFrame(animate);

        updateActiveSection(scrollPercentage);
        // img.onload = function() {
            
        // }
        // console.log(scrollPercentage);

    }

    function drawImageProp(ctx, img, x, y, w, h, offsetX, offsetY) {

        if (arguments.length === 2) {
            x = y = 0;
            w = ctx.canvas.width;
            h = ctx.canvas.height;
        }
    
        // default offset is center
        offsetX = typeof offsetX === "number" ? offsetX : 0.5;
        offsetY = typeof offsetY === "number" ? offsetY : 0.5;
    
        // keep bounds [0.0, 1.0]
        if (offsetX < 0) offsetX = 0;
        if (offsetY < 0) offsetY = 0;
        if (offsetX > 1) offsetX = 1;
        if (offsetY > 1) offsetY = 1;
    
        var iw = img.width,
            ih = img.height,
            r = Math.min(w / iw, h / ih),
            nw = iw * r,   // new prop. width
            nh = ih * r,   // new prop. height
            cx, cy, cw, ch, ar = 1;
    
        // decide which gap to fill    
        if (nw < w) ar = w / nw;                             
        if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;  // updated
        nw *= ar;
        nh *= ar;
    
        // calc source rectangle
        cw = iw / (nw / w);
        ch = ih / (nh / h);
    
        cx = (iw - cw) * offsetX;
        cy = (ih - ch) * offsetY;
    
        // make sure source rectangle is valid
        if (cx < 0) cx = 0;
        if (cy < 0) cy = 0;
        if (cw > iw) cw = iw;
        if (ch > ih) ch = ih;
    
        // fill image in dest. rectangle
        ctx.drawImage(img, cx, cy, cw, ch,  x, y, w, h);
    }

    const $body = document.querySelector('body');

    $('.js-btn-subscribe, #colophon .cta-heading a.btn').bind('click', function(e){
        var scrollY = window.scrollY;
        $('body').css({'top': '-' + scrollY + 'px'});
        $('body').addClass('modal-open').addClass('subscribe-overlay-active');
        e.preventDefault();
    });

    //bind escape key to close modal
    $(document).keyup(function(e) {
        if (e.keyCode === 27) {
            if ($('body').hasClass('modal-open')) {
                $('body').removeClass('modal-open').removeClass('product-enquiry-overlay-active').removeClass('subscribe-overlay-active').removeClass('filter-open');
                window.scrollTo(0, parseInt($('body').css('top')) * -1);
                $('body').css({'top': ''});
                if ($('.more-info-overlay').hasClass('active')) {
                    $('.more-info-overlay').removeClass('active');
                }
            }
        }
    });

    $('.modal-content-wrapper .close').bind('click', function(e){
        e.preventDefault();
    });

    $('body').bind('click', function(e){
        if ($('body').hasClass('modal-open')) {
            if ($(e.target).hasClass('modal-subscribe-overlay') || $(e.target).hasClass('modal-product-enquiry-overlay') || $(e.target).hasClass('modal-content-wrapper') || $(e.target).parent().hasClass('close')) {
                $('body').removeClass('modal-open').removeClass('subscribe-overlay-active').removeClass('product-enquiry-overlay-active');
                window.scrollTo(0, parseInt($('body').css('top')) * -1);
                $('body').css({'top': ''});
            }
        }
    });

    $('.input-wrap').each(function(){
        if ($(this).find('input, select').val() != '' && $(this).find('select option:selected').val() != '') {
            $(this).find('input, select').addClass('filled');
        }
        $(this).find('input').bind('keyup', function(){
            if ($(this).val() != '') {
                $(this).addClass('filled');
            } else {
                $(this).removeClass('filled');
            }
        });
        $(this).find('select').bind('focus, blur', function(){
            if ($(this).val() != '' && $(this).find('option:selected').val() != '') {
                $(this).addClass('filled');
            } else {
                $(this).removeClass('filled');
            }
        });
    });

    $('#posts_per_page_select').bind('focus, blur', function(){
        if ($(this).val() != '' && $(this).find('option:selected').val() != '') {
            $(this).addClass('filled');
        } else {
            $(this).removeClass('filled');
        }
    });

    var timeout;

    function update_filters_documentation(_this, paged, scroll) {
        scroll = (scroll === undefined ? true : scroll);
        if (scroll) {
            // Check if the user is currently focused on the filters
            $('html, body').animate({
                scrollTop: $('.product-documentation').offset().top - 50
            }, 1000);
        }
    
        paged = paged || 1;
        $('.product-documentation ul.document-list').addClass('loading');
        $('.document-filters input[name=paged]').val(paged);
    
        if (typeof timeout !== 'undefined') {
            clearTimeout(timeout);
        }
    
        $('.no-documentation-found').addClass('hidden');
    
        timeout = setTimeout(function() {
            // Use fetch instead of Ext.Ajax.request
            fetch(ajax.url + '?' + $('.document-filters').serialize(), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                timeout: 60000 // You can add a timeout handler if necessary
            })
            .then(response => response.json())  // Equivalent to Ext.decode
            .then(obj => {
                // Update the filters with the response data
                $('.document-filters input[name=paged]').val(obj.current_page);
                $('.document-filters input[name=max_num_pages]').val(obj.num_pages);
    
                if (obj.num_posts === 0) {
                    $('.no-documentation-found').removeClass('hidden');
                    $('.pagination').removeClass('active');
                } else {
                    if (obj.num_pages > 1) {
                        $('.pagination').addClass('active');
                    } else {
                        $('.pagination').removeClass('active');
                    }
                }
    
                // Clear the products grid and update with new data
                $('.product-documentation ul.document-list').html(obj.search_html);
                $('.product-documentation ul.document-list').removeClass('loading');
    
                if (_this !== undefined) {
                    _this.removeClass('loading');
                }
    
                if (!obj.favourites) {
                    if ($('.favourite-documents').is(':visible')) {
                        $('.favourite-documents').hide();
                        $('html, body').animate({ scrollTop: $('.product-documentation').offset().top - 50 }, 500);
                    }
                } else {
                    $('.favourite-documents').show();
                }
    
                $('section.pagination .pagination-wrapper').html(obj.pagination);
            })
            .catch(error => {
                // Replace Ext.Msg.alert with a native alert
                alert('Request Failed: ' + error.message);
            });
        }, 1000);
    }

    $('.document-filters select').bind('change', function(){
        var $this = $(this);
        $this.addClass('loading');
        update_filters_documentation($this, 1, false);
    });

    $('.document-filters input').bind('keyup', function(){
        var $this = $(this);
        $this.addClass('loading');
        update_filters_documentation($this, 1, false);
        if ($(this).attr('name') == 's') {
            $('#mobile-filter input[name="s"]').val($(this).val());
        }
    });

    $('.post-type-archive-rfa-document .pagination').on('click', 'a.prev', function(e){
        $('.document-filters input[name="paged"]').val(parseInt($('.document-filters input[name="paged"]').val()) - 1);
        if (parseInt($('.document-filters input[name="paged"]').val()) < 1) {
            $('.document-filters input[name="paged"]').val(1);
        }
        var paged = $('.document-filters input[name="paged"]').val();
        var $this = $(this);
        $this.addClass('loading');
        update_filters_documentation($this, paged);
        e.preventDefault();
    });
    $('.post-type-archive-rfa-document .pagination').on('click', 'a.next', function(e){
        $('.document-filters input[name="paged"]').val(parseInt($('.document-filters input[name="paged"]').val()) + 1);
        if (parseInt($('.document-filters input[name="paged"]').val()) > parseInt($('.document-filters input[name="max_num_pages"]').val())) {
            $('.document-filters input[name="paged"]').val(parseInt($('.document-filters input[name="max_num_pages"]').val()));
        }
        var paged = $('.document-filters input[name="paged"]').val();
        var $this = $(this);
        $this.addClass('loading');
        update_filters_documentation($this, paged);
        e.preventDefault();
    });

    $('.post-type-archive-rfa-document .pagination').on('click', 'a.page-numbers:not(.next):not(.prev)', function(e){
        $('.document-filters input[name="paged"]').val($(this).text());
        var paged = $('.document-filters input[name="paged"]').val();
        var $this = $(this);
        $this.addClass('loading');
        update_filters_documentation($this, paged);
        e.preventDefault();
    });

    $('#page-header .product-description').on('click', '.category-more-link', function(e){
        var scrollY = window.scrollY;
        $('body').css({'top': '-' + scrollY + 'px'});
        $('body').addClass('modal-open');
        $('.more-info-overlay').addClass('active');
        e.preventDefault();
    });

    $('#page-header').on('click', '.more-info-overlay .more-info-close a', function(e){
        $('.more-info-overlay').removeClass('active');
        $('body').removeClass('modal-open').removeClass('subscribe-overlay-active').removeClass('product-enquiry-overlay-active');
        window.scrollTo(0, parseInt($('body').css('top')) * -1);
        $('body').css({'top': ''});
        e.preventDefault();
    });

    $('.job-listing a.job-title').bind('click', function(e){
        $(this).parents('.job-listings').find('.job-listing').not(':eq(' + $(this).parent().index() + ')').removeClass('active');
        $(this).parent().toggleClass('active');
        e.preventDefault();
    });

    $('.career-position-content ul li a').bind('click', function(e){
        $('#job-type').val($(this).attr('data-position'));
        updateJobFilters();
        $('#job-location').val('all');
        e.preventDefault();
    });

    $('.btn-disabled').bind('click', function(e){
        e.preventDefault();
    });

    $('.btn-jump').bind('click', function(e){
        $('html, body').animate({
            scrollTop: $('a[name="' + $(this).attr('data-jump') + '"').offset().top - 50
        }, 500);
    });

    $('.location-banner select[name="office"]').bind('change', function(e){
        window.location.href = $(this).val();
        e.preventDefault();
    });

    $('.location-banner select[name="team"]').bind('change', function(e){
        window.location.href = $(this).val();
        e.preventDefault();
    });

    if ($('.location-banner select[name="team"]').val() && $('.location-banner select[name="team"] option:selected').attr('data-parent_id')) {
        //get the data attribute of the selected option
        var office = $('.location-banner select[name="team"] option:selected').attr('data-parent_id');
        $('.location-banner select[name="office"]').val($('.location-banner select[name="office"] option[data-id="' + office + '"]').val());
    }

    $('.timeline-filter-wrapper ul li a').on('click', function(e){
        var brand = $(this).attr('data-brand');
        $('.timeline-filter-wrapper ul li').removeClass('active');
        $(this).parent().addClass('active');
        $('.timeline-section:not([data-brand="' + brand + '"])').addClass('hidden');
        $('.timeline-section[data-brand="' + brand + '"]').removeClass('hidden');
        if ($('.brand-filter > ul').hasClass('active')) {
            $('.brand-filter > ul').removeClass('active');
        }
        $('html, body').animate({
            scrollTop: $('.timeline-wrapper').offset().top - ($('#wpadminbar').length ? 220 : 180)
        }, 500);
        e.preventDefault();
    });

    $('.timeline-filter-wrapper a.reset-timeline-filter').on('click', function(e){
        $('.timeline-section').removeClass('hidden');
        $('.timeline-filter-wrapper ul li').removeClass('active');
        $('html, body').animate({
            scrollTop: $('.timeline-wrapper').offset().top - ($('#wpadminbar').length ? 220 : 180)
        }, 500);
        e.preventDefault();
    });

    $('.product-filter-button a, .product-filters a.mobile-close, .apply-filter-btn').on('click', function(e){
        $('.product-filters').addClass('animation-active');
        if ($('body').hasClass('filter-open')) {
            $('body').removeClass('modal-open').removeClass('subscribe-overlay-active').removeClass('product-enquiry-overlay-active').removeClass('filter-open');
            window.scrollTo(0, parseInt($('body').css('top')) * -1);
            $('body').css({'top': ''});
        } else {
            $('body').addClass('filter-open');
            var scrollY = window.scrollY;
            $('body').css({'top': '-' + scrollY + 'px'});
            $('body').addClass('modal-open');
        }
        e.preventDefault();
    });

    $('.scrolling-product-info .product-actions a.make-enquiry').on('click', function(e){
        var scrollY = window.scrollY;
        $('body').css({'top': '-' + scrollY + 'px'});
        $('body').addClass('modal-open').addClass('product-enquiry-overlay-active');
        e.preventDefault();
    });

    $('.brand-filter > a').on('click', function(e){
        $(this).next().toggleClass('active');
        e.preventDefault();
    });

    if ($('.gallery-thumbs').length) {
        $('.gallery-thumbs .thumb-slider ul a').on('click', function(e){
            $('.gallery-thumbs .thumb-slider ul li').removeClass('active');
            $(this).parent().addClass('active');
            thisIndex = $(this).parent().index();
            $('.gallery-slider-wrapper .gallery-slider ul li').removeClass('active');
            $('.gallery-slider-wrapper .gallery-slider ul li').eq(thisIndex).addClass('active');
            var offsetLeft = $('.gallery-slider-wrapper .gallery-slider ul li.active')[0].offsetLeft;
            $('.gallery-slider-wrapper .gallery-slider ul').css({'transform': 'translateX(-' + offsetLeft + 'px)'});
            var currentSlide = $('.gallery-slider-wrapper .gallery-slider ul li.active');
            var nextSlide = currentSlide.next();
            if (!nextSlide.length) {
                $('.gallery-slider-wrapper .navigation li.next').addClass('disabled');
                $('.gallery-thumbs .navigation li.next').addClass('disabled');
            } else {
                $('.gallery-slider-wrapper .navigation li.next').removeClass('disabled');
                $('.gallery-thumbs .navigation li.next').removeClass('disabled');
            }
            var prevSlide = currentSlide.prev();
            if (!prevSlide.length) {
                $('.gallery-slider-wrapper .navigation li.previous').addClass('disabled');
                $('.gallery-thumbs .navigation li.previous').addClass('disabled');
            } else {
                $('.gallery-slider-wrapper .navigation li.previous').removeClass('disabled');
                $('.gallery-thumbs .navigation li.previous').removeClass('disabled');
            }

            e.preventDefault();
        });
        $('.gallery-slider-wrapper .navigation li.previous a').on('click', function(e){
            $('.gallery-slider-wrapper .navigation li.next').removeClass('disabled');
            $('.gallery-thumbs .navigation li.next').removeClass('disabled');
            var currentSlide = $('.gallery-slider-wrapper .gallery-slider ul li.active');
            var prevSlide = currentSlide.prev();
            if (prevSlide.length) {
                $('.gallery-slider-wrapper .gallery-slider ul li').removeClass('active');
                prevSlide.addClass('active');
                var offsetLeft = $('.gallery-slider-wrapper .gallery-slider ul li.active')[0].offsetLeft;
                $('.gallery-slider-wrapper .gallery-slider ul').css({'transform': 'translateX(-' + offsetLeft + 'px)'});
                $('.gallery-thumbs .thumb-slider ul li').removeClass('active');
                $('.gallery-thumbs .thumb-slider ul li').eq(prevSlide.index()).addClass('active');
            }
            var currentSlide = $('.gallery-slider-wrapper .gallery-slider ul li.active');
            var prevSlide = currentSlide.prev();
            if (!prevSlide.length) {
                $('.gallery-slider-wrapper .navigation li.previous').addClass('disabled');
                $('.gallery-thumbs .navigation li.previous').addClass('disabled');
            }
            e.preventDefault();

        });
        $('.gallery-slider-wrapper .navigation li.next a').on('click', function(e){
            $('.gallery-slider-wrapper .navigation li.previous').removeClass('disabled');
            $('.gallery-thumbs .navigation li.previous').removeClass('disabled');
            var currentSlide = $('.gallery-slider-wrapper .gallery-slider ul li.active');
            var nextSlide = currentSlide.next();
            if (nextSlide.length) {
                $('.gallery-slider-wrapper .gallery-slider ul li').removeClass('active');
                nextSlide.addClass('active');
                var offsetLeft = $('.gallery-slider-wrapper .gallery-slider ul li.active')[0].offsetLeft;
                $('.gallery-slider-wrapper .gallery-slider ul').css({'transform': 'translateX(-' + offsetLeft + 'px)'});
                $('.gallery-thumbs .thumb-slider ul li').removeClass('active');
                $('.gallery-thumbs .thumb-slider ul li').eq(nextSlide.index()).addClass('active');
            }
            var currentSlide = $('.gallery-slider-wrapper .gallery-slider ul li.active');
            var nextSlide = currentSlide.next();
            if (!nextSlide.length) {
                $('.gallery-slider-wrapper .navigation li.next').addClass('disabled');
                $('.gallery-thumbs .navigation li.next').addClass('disabled');
            }
            e.preventDefault();
        });

        $('.gallery-thumbs .navigation li.previous a').on('click', function(e){
            $('.gallery-thumbs .navigation li.next').removeClass('disabled');
            $('.gallery-slider-wrapper .navigation li.next').removeClass('disabled');
            var currentSlide = $('.gallery-thumbs .thumb-slider ul li.active');
            var prevSlide = currentSlide.prev();
            if (prevSlide.length) {
                $('.gallery-thumbs .thumb-slider ul li').removeClass('active');
                prevSlide.addClass('active');
                var offsetTop = $('.gallery-thumbs .thumb-slider ul li.active')[0].offsetTop;
                $('.gallery-thumbs .thumb-slider ul').css({'transform': 'translateY(-' + offsetTop + 'px)'});
                $('.gallery-slider-wrapper .gallery-slider ul li').removeClass('active');
                $('.gallery-slider-wrapper .gallery-slider ul li').eq(prevSlide.index()).addClass('active');
                var offsetLeft = $('.gallery-slider-wrapper .gallery-slider ul li.active')[0].offsetLeft;
                $('.gallery-slider-wrapper .gallery-slider ul').css({'transform': 'translateX(-' + offsetLeft + 'px)'});
            }
            var currentSlide = $('.gallery-thumbs .thumb-slider ul li.active');
            var prevSlide = currentSlide.prev();
            if (!prevSlide.length) {
                $('.gallery-thumbs .navigation li.previous').addClass('disabled');
                $('.gallery-slider-wrapper .navigation li.previous').addClass('disabled');
            }
            e.preventDefault();

        });

        $('.gallery-thumbs .navigation li.next a').on('click', function(e){
            $('.gallery-thumbs .navigation li.previous').removeClass('disabled');
            $('.gallery-slider-wrapper .navigation li.previous').removeClass('disabled');
            var currentSlide = $('.gallery-thumbs .thumb-slider ul li.active');
            var nextSlide = currentSlide.next();
            if (nextSlide.length) {
                $('.gallery-thumbs .thumb-slider ul li').removeClass('active');
                nextSlide.addClass('active');
                var offsetTop = $('.gallery-thumbs .thumb-slider ul li.active')[0].offsetTop;
                $('.gallery-thumbs .thumb-slider ul').css({'transform': 'translateY(-' + offsetTop + 'px)'});
                $('.gallery-slider-wrapper .gallery-slider ul li').removeClass('active');
                $('.gallery-slider-wrapper .gallery-slider ul li').eq(nextSlide.index()).addClass('active');
                var offsetLeft = $('.gallery-slider-wrapper .gallery-slider ul li.active')[0].offsetLeft;
                $('.gallery-slider-wrapper .gallery-slider ul').css({'transform': 'translateX(-' + offsetLeft + 'px)'});
            }
            var currentSlide = $('.gallery-thumbs .thumb-slider ul li.active');
            var nextSlide = currentSlide.next();
            if (!nextSlide.length) {
                $('.gallery-thumbs .navigation li.next').addClass('disabled');
                $('.gallery-slider-wrapper .navigation li.next').addClass('disabled');
            }
            e.preventDefault();
        });

        $(window).on('resize', function(){
            $('.gallery-slider-wrapper .gallery-slider ul').addClass('no-transition');
            $('.gallery-thumbs .thumb-slider ul').addClass('no-transition');
            var offsetLeft = $('.gallery-slider-wrapper .gallery-slider ul li.active')[0].offsetLeft;
            var offsetTop = $('.gallery-thumbs .thumb-slider ul li.active')[0].offsetTop;
            $('.gallery-slider-wrapper .gallery-slider ul').css({'transform': 'translateX(-' + offsetLeft + 'px)'});
            if ($('.gallery-thumbs .navigation').is(':visible')) {
                $('.gallery-thumbs .thumb-slider ul').css({'transform': 'translateY(-' + offsetTop + 'px)'});
            } else {
                $('.gallery-thumbs .thumb-slider ul').css({'transform': 'translateY(0px)'});
            }
            setTimeout(function(){
                $('.gallery-slider-wrapper .gallery-slider ul').removeClass('no-transition');
                $('.gallery-thumbs .thumb-slider ul').removeClass('no-transition');
            }, 600);
        });
    }

    if ($('#subscribe-modal-open').length && $('#subscribe-modal-open').val() == 'true') {
        var scrollY = window.scrollY;
        $('body').css({'top': '-' + scrollY + 'px'});
        $('body').addClass('modal-open').addClass('subscribe-overlay-active');
        //remove query string from url
        var url = window.location.href;
        var urlParts = url.split('?');
        window.history.pushState({}, document.title, urlParts[0]);
        
    }

    if ($('.support-menu-outer-wrapper').length) {
        $('.support-menu-outer-wrapper .mobile-dropdown a').on('click', function(e){
            $(this).parents('.support-menu-outer-wrapper').toggleClass('active');
            e.preventDefault();
        });
    }

    if ($('.location-filter-outer-wrapper').length) {
        $('.location-filter-outer-wrapper .mobile-dropdown a').on('click', function(e){
            $(this).parents('.location-filter-outer-wrapper').toggleClass('active');
            e.preventDefault();
        });
    }

    if ($('.performance .contain ul').length) {
        $('.performance .contain ul li a.btn-zoom').on('click', function(e){
            var $this = $(this);
            var $parent = $this.parent();
            var $parentIndex = $parent.index();
            console.log($parentIndex);
            $('.image_gallery_zoom ul li').removeClass('active');
            $('.image_gallery_zoom ul li').eq($parentIndex).addClass('active');
            $('.image_gallery_zoom').addClass('active');
            e.preventDefault();
        });
        //keybind escape to close the modal
        $(document).on('keyup', function(e){
            if (e.which === 27 && $('.image_gallery_zoom').hasClass('active')) {
                $('.image_gallery_zoom').removeClass('active');
            }
        });
        //close the modal when clicking on the close button
        $('.image_gallery_zoom .btn-close').on('click', function(e){
            $('.image_gallery_zoom').removeClass('active');
            e.preventDefault();
        });
    }

    function updateJobFilters() {
        var selectedType = $('.jobs-filter select[name="job-type"]').val();
        var selectedLocation = $('.jobs-filter select[name="job-location"]').val();

        if (selectedType == 'all' && selectedLocation == 'all') {
            $('.job-listing').show();
        } else {
            $('.job-listing').hide();
            $('.job-listing').each(function(){
                var $this = $(this);
                if (selectedType == 'all' && selectedLocation != 'all') {
                    if ($this.attr('data-location') == selectedLocation) {
                        $this.show();
                    }
                } else if (selectedType != 'all' && selectedLocation == 'all') {
                    if ($this.attr('data-position') == selectedType) {
                        $this.show();
                    }
                } else {
                    if ($this.attr('data-position') == selectedType && $this.attr('data-location') == selectedLocation) {
                        $this.show();
                    }
                }
            });
        }
    }

    $('.jobs-filter select').on('change', function(){
        updateJobFilters();
    });

    $('.js-btn-filter').on('click', function(e){
        $('body').toggleClass('slide-in-filter-active');
        e.preventDefault();
    });

    $('#mobile-filter .close-filter').on('click', function(e){
        $('body').toggleClass('slide-in-filter-active');
        e.preventDefault();
    });

    $('#mobile-filter .accordion .accordion-content > ul > li > a').on('click', function(e){
        var selected = $(this).attr('data-select');
        if (!$(this).parent().hasClass('active')) {
            $(this).parents('.accordion-content').find('li').removeClass('active');
            $(this).parents('.accordion-content').parent().parent().removeClass('has-selected');
            $(this).parents('.accordion-content').parent().prev().find('input[type=hidden]').val(selected);
        } else {
            $(this).parents('.accordion-content').parent().prev().find('input[type=hidden]').val('');
        }
        $(this).parent().toggleClass('active');
        $(this).parents('.accordion-content').parent().parent().toggleClass('has-selected');
        e.preventDefault();
    });

    $('#mobile-filter .filter-footer a.btn').on('click', function(e){
        var searchText = $('.document-filters-mobile input[name=s]').val();
        var selectedProductType = $('#selected-product-type').val();
        var selectedDocumentType = $('#selected-document-type').val();
        var sortBy = $('#selected-sort-by').val();
        console.log(searchText, selectedProductType, selectedDocumentType, sortBy);
        if (searchText != '') {
            $('.document-filters input[name=s]').val(searchText);
        }
        if (selectedProductType != '') {
            $('.document-filters select[name=product_type]').val(selectedProductType);
        } else {
            $('.document-filters select[name=product_type]').val('');
        }
        if (selectedDocumentType != '') {
            $('.document-filters select[name=doc_type]').val(selectedDocumentType);
        } else {
            $('.document-filters select[name=doc_type]').val('');
        }
        if (sortBy != '') {
            $('.document-filters select[name=sort_by]').val(sortBy);
        } else {
            $('.document-filters select[name=sort_by]').val('date');
        }
        $('.document-filters input[name=s]').trigger('keyup');
        $('body').toggleClass('slide-in-filter-active');
        e.preventDefault();
    });

    $('body').on('click', function(e){
        if (!$(e.target).parents('.navigation-wrapper').length 
        && !$(e.target).parents('#site-navigation').length 
        && !$(e.target).parents('.menu-item').length 
        && $('#navigation-drop').hasClass('active')) {
            toggleMenuVisibility();
        }
    });

});